// Plain TypeScript enums mirroring `packages/api/prisma/schema.prisma`.
// Kept local so this package stays standalone and has no workspace-only domain dependency.

export const PackageTypeEnum = {
  BOT_TEMPLATE: 'BOT_TEMPLATE',
  CONTENT: 'CONTENT',
  CONTENT_INPUT: 'CONTENT_INPUT',
  FLOW_TEMPLATE: 'FLOW_TEMPLATE',
  NPM_UNPACKED: 'NPM_UNPACKED',
  RWC_INPUT: 'RWC_INPUT',
  S3_BUCKET: 'S3_BUCKET',
  STEP: 'STEP',
  STEP_INPUT: 'STEP_INPUT',
  STEP_TEMPLATE: 'STEP_TEMPLATE',
  TEST_ONLY: 'TEST_ONLY',
  TICKET_INPUT: 'TICKET_INPUT',
  UNKNOWN: 'UNKNOWN',
} as const;
export type PackageTypeEnum =
  (typeof PackageTypeEnum)[keyof typeof PackageTypeEnum];

export const PackageSchemaTypeEnum = {
  LEGACY: 'LEGACY',
  LEGACY_MULTI: 'LEGACY_MULTI',
  EXTERNAL: 'EXTERNAL',
  VUE2_V1: 'VUE2_V1',
  VUE3_V1: 'VUE3_V1',
  UNKNOWN: 'UNKNOWN',
  v1: 'v1',
  v2: 'v2',
} as const;
export type PackageSchemaTypeEnum =
  (typeof PackageSchemaTypeEnum)[keyof typeof PackageSchemaTypeEnum];

export const PackageStatusDetailsStatusEnum = {
  TEST_ONLY: 'TEST_ONLY',
  PENDING: 'PENDING',
  EXTRACTING: 'EXTRACTING',
  UPLOADED: 'UPLOADED',
  BETA: 'BETA',
  RELEASED: 'RELEASED',
  ACCOUNT_BETA: 'ACCOUNT_BETA',
  DEPRECATED: 'DEPRECATED',
} as const;
export type PackageStatusDetailsStatusEnum =
  (typeof PackageStatusDetailsStatusEnum)[keyof typeof PackageStatusDetailsStatusEnum];

export const PackageStatusDetailsLevelEnum = {
  USER: 'USER',
  ACCOUNT: 'ACCOUNT',
  PDE: 'PDE',
} as const;
export type PackageStatusDetailsLevelEnum =
  (typeof PackageStatusDetailsLevelEnum)[keyof typeof PackageStatusDetailsLevelEnum];

export const SortOrderEnum = {
  asc: 'asc',
  desc: 'desc',
} as const;
export type SortOrderEnum = (typeof SortOrderEnum)[keyof typeof SortOrderEnum];
